import React, { useEffect } from "react";
import { fetchMembershipPlans } from "../Redux/actions/membershipActions";
import { useDispatch, useSelector } from "react-redux";
import { APP_ROUTES } from "../PageRouting/pageRoutes";
import Slider from "react-slick";
import { useNavigate } from "react-router-dom";
import {
  MdOutlineKeyboardArrowLeft,
  MdOutlineKeyboardArrowRight,
} from "react-icons/md";

const MembershipSlider = () => {
  const { memberShipPlans, isLoading } = useSelector(
    (state) => state.memberships
  );
  const sliderRef = React.useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchMembershipPlans({ status: 1 }));
  }, []);
  const settings2 = {
    dots: false,
    autoplay: true,
    autoplaySpeed: 3000,
    cssEase: "linear",
    pauseOnHover: true, // 👈 this pauses autoplay when hovered
    draggable: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false, // using custom arrows inside slides
  };
  return (
    <div className="sticky bg-white top-1">
      <Slider ref={sliderRef} {...settings2}>
        {memberShipPlans.map((details, i) => (
          <div
            key={i}
            className="text-center flex items-center justify-center w-full gap-3 px-2 py-4  bg-transparent cursor-pointer"
            onClick={() => navigate(APP_ROUTES.JOINMEMBERSHIP)}
          >
            <button
              onClick={(e) => {
                e.stopPropagation();
                sliderRef.current.slickPrev();
              }}
              className="p-1 bg-gray-100 hover:bg-gray-200 rounded-md shadow-sm mx-2"
            >
              <MdOutlineKeyboardArrowLeft size={20} className="text-gray-700" />
            </button>

            <span>
              <span className="border-2 rounded-md text-base font-sans font-semibold border-[#81CAF4] w-36 text-center p-1 shadow-md">
                {details?.description}
              </span>
              <span className="mx-2 ">
                <span className="text-sm">INR </span>
                <strong>{details?.actualAmount}</strong>
              </span>
              <span className="mx-2">{details?.upto_Discount_Percent}</span>
              <strong className="underline text-primaryColor mx-2">
                View More
              </strong>
            </span>

            <button
              onClick={(e) => {
                e.stopPropagation();
                sliderRef.current.slickNext();
              }}
              className="p-1 bg-gray-100 hover:bg-gray-200 rounded-md shadow-sm mx-2"
            >
              <MdOutlineKeyboardArrowRight
                size={20}
                className="text-gray-700"
              />
            </button>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default MembershipSlider;
